import { User } from '../../utils/user';
import { LaunchDarklyUserInfo } from './buildLaunchDarklyContext';

export const getAdminLaunchDarklyUserInfo = (): LaunchDarklyUserInfo | null => {
  const { idToken, userInfo } = User.getUserInfo();

  // Match AdminAppWrapper login detection: presence of idToken is enough.
  // Do not require isIdTokenValid here — an expired token still carries user
  // claims until checkIdToken refreshes or clears the session.
  if (!idToken || !userInfo?.ams_user_id) {
    return null;
  }

  return {
    ams_user_id: userInfo.ams_user_id,
    email: userInfo.email,
    user_role_v4: userInfo.user_role_v4,
    compression: userInfo.compression,
  };
};
